import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';
import lazyload from './features/lazy-load';
import stickyScroll from "./features/sticky-scroll";
lazyload();
stickyScroll();
const mixins = [tfmixin];
initMain(mixins, {
    TextFill,
    ForumPager: () => import('./vue/components/forum-pager/ForumPager.vue'),
    TrendsHorizontal: () => import('./vue/components/trends/TrendsHorizontal.vue')
}, []);
header();